import React from "react";
import InvoiceSettingTab from "../../components/setting/InvoiceSettingTab";


const Setting = () => {
    return (
        <>
            <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active fs-sm" id="nav-overview-tab" data-bs-toggle="tab"
                            data-bs-target="#nav-general" type="button" role="tab" aria-controls="nav-general"
                            aria-selected="true">
                        Invoice Settings
                    </button>
                </div>
            </nav>
            <div className="tab-content border border-top-0 p-4 rounded-bottom-2" id="nav-tabContent">
                <div className="tab-pane fade show active" id="nav-general" role="tabpanel"
                     aria-labelledby="nav-general-tab" tabIndex="0">
                    <InvoiceSettingTab/>
                </div>
            </div>
        </>
    )
}

export default Setting;